var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.51541 9.03268C3.70721 9.03251 2.91387 8.81548 2.21813 8.40422C1.5224 7.99295 0.949774 7.40253 0.559985 6.69455C0.170197 5.98656 -0.0224694 5.18695 0.00208541 4.37912C0.0266402 3.5713 0.267516 2.78487 0.699586 2.10186C1.13165 1.41886 1.73909 0.864305 2.45851 0.496059C3.17794 0.127812 3.983 -0.0406378 4.78972 0.00828257C5.59643 0.0572029 6.37524 0.3217 7.04489 0.774183C7.71455 1.22667 8.25052 1.85056 8.59689 2.58077H18.0644L20 4.51634L18.0644 6.45191L16.774 5.16153L15.4837 6.45191L14.1933 5.16153L12.9029 6.45191L11.6125 5.16153L10.3221 6.45191H8.59689C8.23054 7.22425 7.65253 7.87675 6.93003 8.33359C6.20753 8.79044 5.37022 9.03286 4.51541 9.03268ZM3.22502 5.80672C3.56726 5.80672 3.89547 5.67077 4.13746 5.42878C4.37946 5.18678 4.51541 4.85857 4.51541 4.51634C4.51541 4.17411 4.37946 3.8459 4.13746 3.6039C3.89547 3.36191 3.56726 3.22596 3.22502 3.22596C2.88279 3.22596 2.55458 3.36191 2.31259 3.6039C2.07059 3.8459 1.93464 4.17411 1.93464 4.51634C1.93464 4.85857 2.07059 5.18678 2.31259 5.42878C2.55458 5.67077 2.88279 5.80672 3.22502 5.80672Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.e0fc1a3674e3241557b2d0a0ec6d5530.svg";
export { ForwardRef as ReactComponent };